import React, {Component} from "react";
import Dialog from '@mui/material/Dialog';
import {
    DialogActions,
    DialogTitle,
    MenuItem,
    Select,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import {connect} from "react-redux";
import {generate_ai_import, get_cluster_data, get_clusters, start_ai_import} from "../../actions/clusters";
import {Alert} from "@mui/lab";
import {withRouter} from "react-router-dom";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import google_translatable_languages from "../../utilities/google_translatable_languages.json";
import {styled} from "@mui/styles";
import CircularProgress from "@mui/material/CircularProgress";
import withStyles from "@mui/styles/withStyles";
import {refresh_ai_availability} from "../../actions/auth";

const StyledTableRow = styled(TableRow)(({theme}) => ({
    // '&:nth-of-type(odd)': {
    //     backgroundColor: theme.palette.action.hover,
    // },
    // hide last border
    '&:first-child td': {
        background: "none",
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const styles = {
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -8,
        marginLeft: -8,
    },
    buttonProgressContainer: {
        position: 'relative'
    },
};

class AIImportDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            step: 0,
            word_count: 5,
            cluster_title: "",
            col_1_language: "-",
            col_2_language: "-",
            col_3_language: "-",
            used_languages: [],
            import_cluster: "new",
            topic: "",
            error: null,
            success: null,
            rows: [],
            importable_rows: 0,
            real_rows: 0,
            message: null,
            importing: false,
            generating: false
        };/*
        this.state = {
            step: 0,
            word_count: 5,
            cluster_title: "My marketing",
            col_1_language: "sk",
            col_2_language: "en",
            col_3_language: "de",
            used_languages: ["sk", "en", "de"],
            import_cluster: this.props.cluster_id ? this.props.cluster_id : "new",
            topic: "marketing",
            error: null,
            success: null,
            rows: [],
            importable_rows: 0,
            importing: false,
            generating: false
        };*/
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    componentDidMount() {
        if (this.props.cluster_id) {
            const sel_cluster = this.props.clusters.find(cluster => cluster.id === this.props.cluster_id);
            let used_languages = [];
            if (sel_cluster["col_1_language"] !== null) {
                used_languages.push(sel_cluster["col_1_language"]);
            }
            if (sel_cluster["col_2_language"] !== null) {
                used_languages.push(sel_cluster["col_2_language"]);
            }
            if (sel_cluster["col_3_language"] !== null) {
                used_languages.push(sel_cluster["col_3_language"]);
            }
            this.setState({
                ...this.state,
                import_cluster: this.props.cluster_id,
                cluster_title: "",
                col_1_language: sel_cluster["col_1_language"] === null ? "-" : sel_cluster["col_1_language"],
                col_2_language: sel_cluster["col_2_language"] === null ? "-" : sel_cluster["col_2_language"],
                col_3_language: sel_cluster["col_3_language"] === null ? "-" : sel_cluster["col_3_language"],
                used_languages
            });
        }
    }

    startImport() {
        this.setState({
            ...this.state,
            error: null,
            success: null,
            importing: true
        });
        this.props.start_ai_import()
            .then(res => {
                this.setState({
                    ...this.state,
                    importing: false,
                    success: res.data.message
                });
                if (this.state.import_cluster === "new") {
                    this.props.get_clusters();
                } else {
                    if (this.props.cluster_id && this.props.cluster_id === this.state.import_cluster) {
                        this.props.get_cluster_data(this.props.cluster_id);
                    }
                }
                this.props.refresh_ai_availability();
            })
            .catch(err => {
                this.setState({
                    ...this.state,
                    importing: false,
                    error: err.response.data.error
                });
                this.props.refresh_ai_availability();
            });
        // todo close dialog and redirect to cluster ??
    }

    generate() {
        this.setState({
            ...this.state,
            error: null,
            success: null,
            generating: true
        });
        this.props.generate_ai_import({
            'cluster_id': this.state.import_cluster === "new" ? null : this.state.import_cluster,
            'cluster_title': this.state.cluster_title,
            'topic': this.state.topic,
            'word_count': this.state.word_count,
            'col_1_language': this.state.col_1_language === "-" ? null : this.state.col_1_language,
            'col_2_language': this.state.col_2_language === "-" ? null : this.state.col_2_language,
            'col_3_language': this.state.col_3_language === "-" ? null : this.state.col_3_language
        })
            .then(res => {
                if (res.data) {
                    this.setState({
                        ...this.state,
                        rows: res.data.rows,
                        importable_rows: res.data.importable_rows,
                        real_rows: res.data.real_rows,
                        message: res.data.message,
                        step: 1,
                        generating: false
                    });
                    this.props.refresh_ai_availability();
                }
            })
            .catch(err => {
                this.setState({
                    ...this.state,
                    error: err.response.data.error, // todo refactor na err message
                    errors: err.response.data.errors,
                    generating: false
                });
                this.props.refresh_ai_availability();
            });
    }

    isGenerateDisabled() {
        return this.state.word_count > 50 || this.state.word_count <= 0 || this.state.topic.length < 3 || this.state.used_languages.length === 0;
    }

    setLanguageInput(i, value) {
        let used_languages = [];
        if (value !== "-") {
            used_languages.push(value);
        }
        [1, 2, 3].filter(e => e !== i).map((i2) => {
            if (this.state[`col_${i2}_language`] !== "-") {
                used_languages.push(this.state[`col_${i2}_language`]);
            }
        });
        this.setState({
            ...this.state,
            ["col_" + i + "_language"]: value,
            used_languages
        });
    }

    render() {
        const selected_cluster = this.props.clusters.find(cluster => cluster.id === this.state.import_cluster);
        const active_clusters_count = this.props.clusters.filter((c) => !c.disabled).length;

        return <>
            <Snackbar
                open={this.state.success !== null}
                autoHideDuration={4000}
                onClose={this.props.handleClose}
                severity="success"
            >
                <Alert onClose={this.props.handleClose} severity="success" sx={{width: '100%'}}>
                    {this.state.success}
                </Alert>

            </Snackbar>

            <Dialog open={this.state.success === null} onClose={this.props.handleClose}>
                <DialogTitle>Vocabulary prompt</DialogTitle>
                {this.state.step === 0 && <>
                    <DialogContent>
                        {this.state.error && <Alert
                            style={{marginBottom: 15}}
                            severity="error">{this.state.error}</Alert>}
                        <div style={{marginBottom: 10}}>
                            <Typography component="span">Generate</Typography>
                            <Select
                                style={{margin: "0 10px"}}
                                value={this.state.word_count}
                                variant="standard"
                                onChange={(e) => this.setState({...this.state, word_count: e.target.value})}
                            >
                                {[5, 10, 15, 20].map((number) =>
                                    <MenuItem value={number} key={number}>{number}</MenuItem>
                                )}
                            </Select>
                            <Typography component="span">words about</Typography>
                            <TextField style={{margin: "0 10px"}}
                                       variant="standard" required
                                       minLength={3}
                                       value={this.state.topic} type="text"
                                       onChange={(e) => this.setState({
                                           ...this.state,
                                           topic: e.target.value
                                       })}

                            />
                            <Typography component="span">and import them into</Typography>
                            <Select variant="standard"
                                    style={{margin: "0 10px"}}
                                    value={this.state.import_cluster}
                                    onChange={(e) => {
                                        if (e.target.value === "new") {
                                            this.setState({
                                                ...this.state,
                                                import_cluster: e.target.value,
                                                col_1_language: "-",
                                                col_2_language: "-",
                                                col_3_language: "-",
                                                used_languages: []
                                            });
                                        } else {
                                            const sel_cluster = this.props.clusters.find(cluster => cluster.id === e.target.value);
                                            let used_languages = [];
                                            if (sel_cluster["col_1_language"] !== null) {
                                                used_languages.push(sel_cluster["col_1_language"]);
                                            }
                                            if (sel_cluster["col_2_language"] !== null) {
                                                used_languages.push(sel_cluster["col_2_language"]);
                                            }
                                            if (sel_cluster["col_3_language"] !== null) {
                                                used_languages.push(sel_cluster["col_3_language"]);
                                            }
                                            this.setState({
                                                ...this.state,
                                                import_cluster: e.target.value,
                                                cluster_title: "",
                                                col_1_language: sel_cluster["col_1_language"] === null ? "-" : sel_cluster["col_1_language"],
                                                col_2_language: sel_cluster["col_2_language"] === null ? "-" : sel_cluster["col_2_language"],
                                                col_3_language: sel_cluster["col_3_language"] === null ? "-" : sel_cluster["col_3_language"],
                                                used_languages
                                            });
                                        }
                                    }}
                            >
                                {

                                    (
                                        (!this.props.auth.user.premium && active_clusters_count < 3)
                                        ||
                                        this.props.auth.user.premium
                                    )

                                    && <MenuItem value={"new"} key={"new"}>new cluster</MenuItem>}
                                {this.props.clusters.map((cluster) =>
                                    cluster.shared_by === null &&
                                    <MenuItem value={cluster.id} key={cluster.id}>{cluster.title}</MenuItem>
                                )}
                            </Select>
                            {this.state.import_cluster === "new" && <>
                                <Typography component="span">named</Typography>
                                <TextField style={{margin: "0 10px"}}
                                           variant="standard" required
                                           minLength={3}
                                           value={this.state.cluster_title} type="text"
                                           onChange={(e) => this.setState({
                                               ...this.state,
                                               cluster_title: e.target.value
                                           })}

                                /></>}
                            <Typography component="span">in languages:</Typography>
                        </div>

                        {/*                    CONFIG: {this.state.word_count} - {this.state.topic} - {this.state.import_cluster}
                    <hr/>*/}
                        {this.state.import_cluster === "new" && <table>
                            <tbody>
                            {/*                        <tr>
                            <th>
                                <Typography component="span">Column</Typography>
                            </th>
                            <th>
                                <Typography component="span">Language</Typography>
                            </th>
                        </tr>*/}
                            {[1, 2, 3].map((i) =>
                                <tr key={"ddas" + i}>
                                    <td>
                                        <Typography component="span">Column {i} language:</Typography>
                                    </td>
                                    <td style={{paddingLeft: 10}}>
                                        <Select
                                            variant="standard"
                                            name={`col_${i}_language`}
                                            value={this.state[`col_${i}_language`]}
                                            disabled={i === 2 && this.state[`col_1_language`] === "-" || i === 3 && this.state[`col_2_language`] === "-"}
                                            onChange={(e) => this.setLanguageInput(i, e.target.value)}
                                        >
                                            <MenuItem value="-">
                                                -- Empty --
                                            </MenuItem>
                                            {Object.entries(google_translatable_languages)
                                                .filter(l => !this.state.used_languages.includes(l[0]) || this.state[`col_${i}_language`] === l[0])
                                                .map(l =>
                                                    <MenuItem
                                                        key={"c-" + l[0] + "-" + i}
                                                        value={l[0]}>{l[1]}</MenuItem>)}
                                        </Select>
                                    </td>
                                </tr>
                            )}


                            </tbody>
                        </table>}

                        {/*{selected_cluster[`col_1_name`] !== null ? "1": "NULL"}
                    {selected_cluster[`col_2_name`] !== null ? "2": "NULL"}
                    {selected_cluster[`col_3_name`] !== null ? "3": "NULL"}*/}
                        {this.state.import_cluster !== "new" && <table>
                            <tbody>
                            {/*{selected_cluster.title}<br/>*/}
                            {/*                        <tr>
                            <th>
                                <Typography component="span">Column</Typography>
                            </th>
                            <th>
                                <Typography component="span">Language</Typography>
                            </th>
                        </tr>*/}
                            {[1, 2, 3].map((i) =>
                                    selected_cluster[`col_${i}_name`] !== null && <tr key={"sf" + i}>
                                        <td>
                                            <Typography component="span">Language for '{selected_cluster[`col_${i}_name`]}'
                                                column:</Typography>
                                        </td>
                                        <td style={{paddingLeft: 10}}>
                                            <Select
                                                variant="standard"
                                                name={`col_${i}_language`}
                                                value={this.state[`col_${i}_language`]}
                                                required
                                                onChange={(e) => this.setLanguageInput(i, e.target.value)}
                                            >
                                                <MenuItem value="-">
                                                    -- Empty --
                                                </MenuItem>
                                                {Object.entries(google_translatable_languages)
                                                    .filter(l => !this.state.used_languages.includes(l[0]) || this.state[`col_${i}_language`] === l[0])
                                                    .map(l =>
                                                        <MenuItem
                                                            key={"c-" + l[0] + "-" + i}
                                                            value={l[0]}>{l[1]}</MenuItem>)}
                                            </Select>
                                        </td>
                                    </tr>
                            )}
                            </tbody>
                        </table>}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.props.handleClose} color="secondary">
                            Close
                        </Button>
                        <span className={this.props.classes.buttonProgressContainer}>
                        <Button onClick={this.generate.bind(this)}
                                color="primary"
                                disabled={this.state.generating || this.isGenerateDisabled()}>
                            Generate {!(this.state.importing || !this.state.import || this.state.files.length !== 1) && 5 + " rows"}
                        </Button>
                            {this.state.generating && <CircularProgress size={16}
                                                                        className={this.props.classes.buttonProgress}/>}
                    </span>
                    </DialogActions>
                </>}
                {this.state.step === 1 && <>
                    <DialogContent style={{width: 500}}>
                        {this.state.success && <Alert
                            style={{marginBottom: 15}}>{this.state.success}</Alert>}
                        {this.state.error && <Alert
                            style={{marginBottom: 15}}
                            severity="error">{this.state.error}</Alert>}
                        {this.state.real_rows > this.state.importable_rows &&
                            <Alert
                                style={{marginTop: 15, marginBottom: 15}}
                                severity="info">Generated data contains {this.state.real_rows} rows, but your plan
                                supports
                                only 50 rows
                                per
                                cluster. {this.state.real_rows - this.state.importable_rows} last rows will not be
                                imported.<Typography
                                    style={{fontSize: "0.875rem"}}>Upgrade to <span
                                    style={{fontWeight: 900, cursor: "pointer", color: "#00ff00"}}
                                    onClick={() => {
                                        this.props.history.push('/premium')
                                    }}>PREMIUM</span> with No Limit of Rows!</Typography></Alert>}
                        {this.state.message &&
                            <Alert
                                style={{marginTop: 15, marginBottom: 15}}
                                severity="info">{this.state.message}</Alert>}
                        <TableContainer sx={{maxHeight: 440}}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{background: "none"}}>
                                            {this.state["col_1_language"] !== "-" && google_translatable_languages[this.state["col_1_language"]]}
                                        </TableCell>
                                        <TableCell style={{background: "none"}}>
                                            {this.state["col_2_language"] !== "-" && google_translatable_languages[this.state["col_2_language"]]}
                                        </TableCell>
                                        <TableCell style={{background: "none"}}>
                                            {this.state["col_3_language"] !== "-" && google_translatable_languages[this.state["col_3_language"]]}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.rows.map((row, i) => <StyledTableRow key={"roww" + i}>
                                        {row.map((col, j) => <TableCell key={"col" + i + "-" + j}>
                                            {col}
                                        </TableCell>)}
                                    </StyledTableRow>)}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            this.setState({
                                ...this.state,
                                step: 0,
                                rows: [],
                                importable_rows: 0,
                                real_rows: 0,
                                message: null
                            });
                        }} color="secondary" style={{
                            marginRight: "auto"
                        }} disabled={this.state.importing}>
                            Back
                        </Button>
                        <Button onClick={this.props.handleClose} color="secondary">
                            Cancel
                        </Button>
                        <span className={this.props.classes.buttonProgressContainer}>
                        <Button onClick={this.startImport.bind(this)}
                                color="primary"
                                disabled={this.state.importing || this.state.success !== null}>
                            {this.state.import_cluster !== "new" && "Import " + this.state.importable_rows + " rows"}
                            {this.state.import_cluster === "new" && "Create cluster"}
                        </Button>
                            {this.state.importing && <CircularProgress size={16}
                                                                       className={this.props.classes.buttonProgress}/>}
                    </span>
                    </DialogActions>
                </>}
            </Dialog>

        </>
    }
}

const mapStateToProps = state => ({
    error: state.clusters.error,
    auth: state.auth,
    clusters: state.clusters.clusters
});
export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {generate_ai_import, start_ai_import, get_clusters, get_cluster_data, refresh_ai_availability}
)(AIImportDialog)));
